import ClientOne from "../../assets/images/jpeg/clientSlideOne.jpeg";
import ClientTwo from "../../assets/images/jpeg/clientSlideTwo.jpeg";
import ClientThree from "../../assets/images/jpeg/clientSlideThree.jpeg";
import ClientFOur from "../../assets/images/jpeg/clientSlideFour.jpeg";
import ClientFive from "../../assets/images/jpeg/clientSlideFive.jpeg";
import ClientSix from "../../assets/images/jpeg/clientSlideSix.jpeg";
import ClientSeven from "../../assets/images/jpeg/clientSlideSeven.jpeg";
import ClientEight from "../../assets/images/jpeg/clientSlideEight.jpeg";

import ImageSlider from "../../components/ImageSlider";

import "./index.scss";

const ClientsSlider = () => {
  let slides = [
    <img className="client-image" src={ClientOne} alt="1" />,
    <img className="client-image" src={ClientTwo} alt="2" />,
    <img className="client-image" src={ClientThree} alt="3" />,
    <img className="client-image" src={ClientFOur} alt="4" />,
    <img className="client-image" src={ClientFive} alt="5" />,
    <img className="client-image" src={ClientSix} alt="6" />,
    <img className="client-image" src={ClientSeven} alt="7" />,
    <img className="client-image" src={ClientEight} alt="8" />,
  ];
  return (
    <div className="clients-slider">
      <div className="title">Omni Moments</div>
      <ImageSlider slides={slides} />
    </div>
  );
};
export default ClientsSlider;
